// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import moment from 'moment-timezone'

import {
  SYSTEM_MAINTENANCE_END_HOUR,
  SYSTEM_MAINTENANCE_START_HOUR,
} from 'Routes/SystemMaintenanceCheck/constants'

/**
 * takes Moment instance, and determines if we're within the maintenance window
 * @param {moment.Moment} currentMomentInEastern
 * @returns {boolean}
 */
const applicationIsWithinMaintenanceMode = currentMomentInEastern => {
  // hours here is based on 24h
  const hours = currentMomentInEastern.hours()

  return SYSTEM_MAINTENANCE_START_HOUR <= hours && hours < SYSTEM_MAINTENANCE_END_HOUR
}

export default applicationIsWithinMaintenanceMode
